(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-native-slider]').forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const track = slider.querySelector('.gapd-native-slider-track');
      const slides = [...track.children];
      const dots = [...slider.querySelectorAll('[data-slide-index]')];
      const pause = slider.querySelector('[data-slide-pause]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, timer, paused = reduced.matches;
      function mark(index) {
        current = index;
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }
      function show(index, smooth = true) {
        const next = (index + slides.length) % slides.length;
        track.scrollTo({left: next * track.clientWidth, behavior: smooth && !reduced.matches ? 'smooth' : 'instant'});
        mark(next);
      }
      function stop() { clearInterval(timer); }
      function start() { stop(); if (!paused && !document.hidden) timer = setInterval(() => show(current + 1), 8000); }
      slider.querySelectorAll('[data-slide-direction]').forEach(button => button.addEventListener('click', () => { show(current + Number(button.dataset.slideDirection)); start(); }));
      dots.forEach((dot, i) => dot.addEventListener('click', () => {show(i); start();}));
      pause.addEventListener('click', () => {
        paused = !paused;
        pause.textContent = paused ? '▶' : 'Ⅱ';
        pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        start();
      });
      track.addEventListener('scroll', () => mark(Math.round(track.scrollLeft / track.clientWidth)), {passive: true});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();show(current + (event.key === 'ArrowRight' ? 1 : -1));start();}
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', start);
      const resize = new ResizeObserver(() => show(current, false));
      resize.observe(track);
      start();
    });
    root.querySelectorAll('[data-native-speedy]').forEach(card => {
      const select = card.querySelector('[data-speedy-size]');
      const button = card.querySelector('[data-speedy-add]');
      const price = card.querySelector('[data-speedy-price]');
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        button.disabled = !select.value || select.selectedOptions[0].disabled;
        if (select.selectedOptions[0].dataset.price) price.textContent = select.selectedOptions[0].dataset.price;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
